/*
 * GEHC CONFIDENTIAL
 *
 * Copyright(c) 2021, 2025, GE Healthcare.
 * All rights reserved.
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, Output } from '@angular/core';
import * as _ from 'underscore';

@Component({
  selector: 'wfm-select-filter-pannel',
  templateUrl: './select-filter-pannel.component.html',
  styleUrls: ['./select-filter-pannel.component.scss']
})
export class SelectFilterPannelComponent implements OnChanges {
  @Input() items: Array<any> = [];

  @Input() search = false;

  @Input() seperatorKey = '';

  @Input() context: string;

  @Input() labelField = '';

  @Input() value: any;

  @Input() multiple = false;

  @Input() defaultSelection: any;

  @Input() error = false;

  unSelectDefault = false;

  query = '';

  filteredItems: Array<any>;

  selectedAll = false;

  isAllIndeterminate = false;

  @Output() valueChange = new EventEmitter<any>();

  private window: Window;

  constructor(@Inject(DOCUMENT) private document) {
    this.window = this.document.defaultView;
  }

  ngOnChanges() {
    if (!this.error && this.defaultSelection && !this.unSelectDefault) {
      if (Array.isArray(this.defaultSelection)) {
        this.defaultSelection.forEach(e => {
          if (!_.contains(this.value, e)) {
            this.itemClick(e);
          }
        });
      } else {
        if (!_.contains(this.value, this.defaultSelection)) {
          this.itemClick(this.defaultSelection);
        }
      }
    }
  }

  toggleSelectAll() {
    this.selectedAll = !this.selectedAll;
    if (this.selectedAll) {
      this.items.forEach(item => {
        if (!_.contains(this.value, item) && item.availableForUser) {
          this.itemClick(item);
        }
      });
    } else {
      this.value.forEach(item => {
        this.itemClick(item);
      });
    }
  }

  itemClick(item: any) {
    this.window.setTimeout(() => {
      if (this.multiple) {
        if (!this.value) {
          this.value = [];
        }

        const index = this.value.indexOf(item);
        if (index > -1) {
          (this.value as any[]).splice(index, 1);
        } else {
          this.value.push(item);
        }
      } else {
        this.value = item;
      }
      this.selectedAll = this.value.length === this.items.filter(item => item.availableForUser).length;
      if (!this.selectedAll && this.value.length > 0) {
        this.isAllIndeterminate = true;
      } else {
        this.isAllIndeterminate = false;
      }

      this.updateFilteredItems();

      if (this.value.length === 0 && !this.unSelectDefault) {
        this.unSelectDefault = true;
      }
      this.valueChange.emit(this.value);
    }, 0);
  }

  updateFilteredItems() {
    const items = this.items || [];
    if (!this.search || !this.query) {
      this.filteredItems = items;
    } else {
      this.filteredItems = this.filterItems(items);
    }
  }

  isSeperatorRequired(item: any, index: number, items: any[], last: boolean): boolean {
    if (!this.seperatorKey || !this.isListOfObjects || last) {
      return false;
    }
    return item[this.seperatorKey] !== items[index + 1][this.seperatorKey];
  }

  get isListOfObjects(): boolean {
    return typeof this.items[0] === 'object';
  }

  private filterItems(items: any[]): any[] {
    return items.filter(
      item => (this.isListOfObjects ? item[this.labelField] : item).toLowerCase().indexOf(this.query.toLowerCase()) >= 0
    );
  }
}
